import React from 'react';
import Alert from 'react-bootstrap/Alert';
import {Link, useParams} from "react-router-dom";

function InviteAccepted(props : any) {
      let { inviteCode }  = useParams();

  fetch('https://9ap0wh9yya.execute-api.eu-central-1.amazonaws.com/compare-accepted', {
        method : 'POST',
        body : JSON.stringify({inviteCode:inviteCode, acceptor:props.username}),
        headers: {
        'Authorization': `Bearer ${props.jwt}`,
      }
  }).then(response => {
    if(response.status === 200){
      return response.json();
    }
  });

	  const renderMore = () => {
	  	if (props.quiz.length >0) {
	  		return (<h5>
	  		It looks like you've already completed the quiz before<br />
	  			<Link to="/user/premium/send-invite">click here</Link> to go to your available comparisons
	  		</h5>)
	  	}else{
		  	return (<h5> Please <Link to="/user/premium/quiz">click here</Link> to start the quiz</h5>);
	  	}
	  }

	    return (
	    	<div>
	    		<br /><br /><br />
     		<Alert  variant="success">
     		Thank you for accepting the invitation !
     		<br /> we will notify the sender promptly
          	</Alert>
          	{renderMore()}
	     	</div>
	     );
  }
export default InviteAccepted;